import { useCallback, useContext } from 'react';
import MetricsContext from '../../../../../../contexts/MetricsContext';
import MetricUsageLookupContext from '../../../../../../contexts/MetricUsageLookupContext';

const useGetFieldMetricUsage = () => {
  const { allMetrics } = useContext(MetricsContext);
  const { metricLookup } = useContext(MetricUsageLookupContext);

  const getUsageCount = useCallback(
    (metricId: string) => {
      return metricLookup[metricId]?.usageCount ?? 0;
    },
    [metricLookup],
  );

  const getFieldMetricUsage = useCallback(
    (field: string, dataset: string) => {
      const metricUsages: Metrics.NormalMetric[] = allMetrics
        .filter((metric) => metric.status !== 'archived')
        .filter((metric) => metric.field === field)
        .filter((metric) => metric.dataType === dataset)
        // Order by usage count descending from the metricUsageLookup
        .sort((a, b) => getUsageCount(b.id) - getUsageCount(a.id));

      return metricUsages;
    },
    [allMetrics, getUsageCount],
  );

  return getFieldMetricUsage;
};

export default useGetFieldMetricUsage;
